import React, { Component } from "react";
import { Button } from "reactstrap";
import Request from '../../../../../config/Request.js'
// import Select from 'react-select';
import DatePicker from "react-datepicker";
import CurrencyInput from "react-currency-input";
import { connect } from "react-redux";
//Import Asset presenter
import Presenter from "../../../../../asset/asset/presenter.js";
//Import Tracking presenter
// import TrackingPresenter from '../../../../../asset/tracking/presenter.js'
//import master record helper
import MasterRecordHelperModel from "../../../../../asset/asset/helper/master.js";
//import render helper
import RenderHelperModel from "../../../../../asset/asset/helper/render.js";
//import form helper
import FormHelper from "../../../../../asset/asset/helper/form.js";
//Import Datepicker
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
//Import Message props
import MessageProperties from "../../../../../config/message.js";
//import requset props helper
import RequestProps from "../../../../../asset/asset/helper/request_props.js";
//import Permission Properties
import PermissionProperties from "../../../../../config/permission.js";
//Import Super Model Record ADODB
import { SuperADODB, Exec } from "../../../../../helper/request.action.js";
//Import Image File Upload
// import FineUploaderTraditional from 'fine-uploader-wrappers'
import Gallery from "react-fine-uploader";
import "react-fine-uploader/gallery/gallery.css";
//Import Tracking Asset Reqest Props helper
// import TrackingRequestProps from '../../../../../asset/tracking/helper/request_props.js'
//Import Image Uploader Request Props
import ImageUploader from "../../../../../asset/photo/helper/request_props.js";

import UserHelper from "../../../../../helper/user.js";

import { StoreUserInfoFromMobile } from "user/action";

// Import Toast src: https://fkhadra.github.io/react-toastify/
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

//=======site and location==========//
// import PresenterSite from '../../../../../location/site/presenter.js'
// import PermissionProperties from '../../../../config/permission.js'
// import RenderHelper from '../../../../../location/site/helper/render.js'
// import ModalHelper from '../../../../../location/site/helper/modal.js'
// import MasterHelper from '../../../../../location/site/helper/master.js'
// import FormHelperSite from '../../../../../location/site/helper/form.js'
// import MessageProperties from '../../../../../config/message.js'
// import RequestProperties from '../../../../../location/site/helper/request.props.js'

// import ModalHelperLocation from '../../../../../location/location/helper/modal.js'
// import LocationRow from '../../../../../location/site/helper/children/locationRow.js';
// import RequestPropertiesLocation from '../../../../../location/location/helper/request.props.js'
// import PresenterLocation from '../../../../../location/location/presenter.js'
// import FormHelperLocation from '../../../../../location/location/helper/form.js'

// import FormHelperContact from '../../../../../master/contact/helper/form.js';
// import RequestPropertiesContact from '../../../../../master/contact/helper/request.props.js'
// import PresenterContact from '../../../../../master/contact/presenter.js'

// import FormHelperSiteType from '../../../../../master/site_type/helper/form.js'
// import RequestPropertiesSiteType from '../../../../../master/site_type/helper/request.props.js';
// import PresenterSiteType from '../../../../../master/site_type/presenter.js';

// import FormHelperSiteStatus from '../../../../../master/site_status/helper/form.js'
// import RequestPropertiesSiteStatus from '../../../../../master/site_status/helper/request.props.js'
// import PresenterSiteStatus from '../../../../../master/site_status/presenter.js'

// import ModalSelectInMap from '../../../../../utils/Modal/ModalSelectInMap.js';
// import Module from '../../../../../utils/Render.js'
import SelectQuery from "component/SelectQuery";
import ModalQuestion from "component/ModalQuestion";
import ModalMaintenanceAdd from "maintenance/helper/component/Modal/ModalMaintenanceAdd";
import ModalRegisterSite from "../../../../../location/site/helper/component/Modal.js";
import ModalRegisterLocation from "../../../../../location/location/helper/component/Modal.js";
import windowStop from "../../../../../utils/windowStop.js";
import lang from "config/language";
import PopoverHelper from "utils/PopoverHelper";
//==================================//
const { ReactNativeWebView } = window;

class AssetRegistrationForm extends Component {
  LocationOption = [];
  renderHelper = null;
  Uploader = null;
  MasterRecord = null;
  constructor(props) {
    super(props);
    // console.log(this.props)

    this.state = {
      //Registration Model
      Tag: "",
      Name: "",
      Description: "",
      SerialNumber: "",
      PurchasedDate: moment(),
      PurchaseCurrency: "",
      PurchaseOrder: "",
      PurchaseVendorName: "",
      Status: undefined,
      Type: undefined,
      Site: undefined,
      Location: undefined,
      PurchasePrice: 0,
      MaxDay: "",
      WarrantyPeriod: 0,
      Make: "",
      Model: "",
      siteEdit: true,

      //register site
      dropdownOpen: false,
      Button: false,
      locationEl: [],
      Register: {
        modal: false,
        Tag: "",
        Name: "",
        Description: "",
        TypeAlias: "",
        Address: "",
        Address2: "",
        CityAbbreviations: "",
        Postal: "",
        Longitude: "",
        Latitude: "",
        GoogleMapURL: "",
        GoogleStreetviewURL: "",
        StatusAlias: "",
        ProjectName: "",
        ContactAlias: ""
      },
      //register location
      RegisterLocation: {
        modal: false,
        Name: "",
        Description: "",
        ContactAlias: "",
        SiteAlias: ""
      },
      Map: {
        modal: false
      },
      RegisterContact: {
        modal: false,
        Name: "",
        Phone: "",
        Email: ""
      },
      RegisterSiteType: {
        modal: false,
        Name: "",
        Description: ""
      },
      RegisterSiteStatus: {
        modal: false,
        Name: "",
        Description: ""
      },
      modalRegisterSite: false,
      modalRegisterLocation: false,
      modalQuestion: false,
      modalMaintenance: false
    };
    this.is_lite = ReactNativeWebView && props.UserReducer.props.is_lite;
    this.newAsset = {};
    this.Uploader = new ImageUploader(
      this.props.UserReducer,
      null,
      this.__OnUploadImageSuccess__,
      this
    );
    this.__InitRenderHelper__();
    this.__InitMasterRecordHelper__();

    //==========location and site========
    // this.MasterRecord                      = new MasterHelper(this)
    this.siteData = {};
    // this.__generateLocationRow__           = this.__generateLocationRow__.bind(this)
    // this.__ToogleRegisterContactModal__    = this.__ToogleRegisterContactModal__.bind(this);
    // this.__ToogleRegisterModal__           = this.__ToogleRegisterModal__.bind(this);
    // this.__ToogleRegisterLocationModal__   = this.__ToogleRegisterLocationModal__.bind(this);
    // this.__ToogleRegisterSiteTypeModal__   = this.__ToogleRegisterSiteTypeModal__.bind(this);
    // this.__ToogleRegisterSiteStatusModal__ = this.__ToogleRegisterSiteStatusModal__.bind(this);
    // this.__ToogleMapModal__                = this.__ToogleMapModal__.bind(this);

    this.toggleModalMaintenance = this.toggleModalMaintenance.bind(this);
    this.openModalRegisterLocation = this.openModalRegisterLocation.bind(this);
    this.closeModalRegisterLocation = this.closeModalRegisterLocation.bind(
      this
    );

    this.openModalRegisterSite = this.openModalRegisterSite.bind(this);
    this.closeModalRegisterSite = this.closeModalRegisterSite.bind(this);

    this.handleChangePurchase = this.handleChangePurchase.bind(this);
    this.handleMobile = this.handleMobile.bind(this);
    // this.handleChangePurchaseCurency       = this.handleChangePurchaseCurency.bind(this);
    //===================================
  }
  __InitMasterRecordHelper__() {
    this.MasterRecordHelper = new MasterRecordHelperModel(
      this.props.RunRedux,
      this.props.UserReducer,
      this.props.AssetStatusReducer,
      // this.props.AssetTypeReducer,
      this.props.VendorReducer
      // this.props.LocationReducer,
      // this.props.SiteReducer,
      // this.props.ContactReducer,
      // this.props.SiteTypeReducer,
      // this.props.SiteStatusReducer
    );
    this.MasterRecordHelper.LoadMasterPropsField();
  }

  handleChangePurchase(event, maskedvalue, floatvalue) {
    this.setState({ PurchasePrice: floatvalue });
  }

  __InitRenderHelper__() {
    this.renderHelper = new RenderHelperModel();
  }
  __OnPurchasedDateChange__(value, self) {
    self.setState({
      PurchasedDate: value
    });
  }

  //Handler
  __HandleVendorChanged__(val, Reducer, run_redux) {
    if (val === null) {
      return;
    }
    if (val.className === "Select-create-option-placeholder") {
      // console.log(Reducer)
      var NewOption = Reducer.rs.concat({ Name: val.value });
      run_redux(
        SuperADODB("MasterVendorSetRS", {
          next: null,
          previous: null,
          rs: NewOption,
          query: ""
        })
      );
    }
    this.setState({ PurchaseVendorName: val.value });
  }
  __HandleSiteChanged__(val) {
    // console.log(val)
    if (val !== null) {
      this.siteData = val;
      this.setState(
        {
          Site: val.value,
          Location: "",
          Button: true,
          RegisterLocation: {
            ...this.state.RegisterLocation,
            SiteAlias: val.value
          }
        },
        () => this._location.reload("", true)
      );
      // this.LocationOption = this.renderHelper.RenderMasterAutoComplete({rs:this.props.LocationReducer.rs.filter((LocationObj)=>  LocationObj.Site === val.value )},true)
      // return
    } else {
      this.setState({
        Site: "",
        Location: "",
        Button: false,
        RegisterLocation: {
          ...this.state.RegisterLocation,
          SiteAlias: "3123123123123"
        }
      });
      // this.LocationOption = this.renderHelper.RenderMasterAutoComplete({rs:{}},true)
    }
    // this.refs["_location"].componentDidMount();
    // this._location.reload();
  }

  __HandleLocationChanged__(val) {
    if (val !== null) {
      this.setState({ Location: val.value });
      return;
    }
    this.setState({ Location: "" });
  }

  __HandleChanged__(state, val) {
    if (val != null) {
      this.setState({ [state]: val.value });
      return;
    }
    this.setState({ [state]: "" });
  }
  __RegisterDone__(self, response) {
    toast.success(MessageProperties.SUCEESS.MODEL.ASSET.REGISTRATION);
    let nextPath = "/admin";
    if (ReactNativeWebView) {
      nextPath = "/single-page";
    }
    self.props.history.push(
      nextPath +
        "/master-asset-details-" +
        self.Uploader.Obj.methods._options.request.params.AssetAlias +
        "/",
      true
    );
  }
  __OnUploadImageSuccess__(self, params) {
    self.__RegisterDone__(self);
  }
  __OnRegisterTrackingSuccess__(self, response) {
    // console.log(self.Uploader.Obj)
    if (self.Uploader.Obj.methods.getFile(0) !== null) {
      self.Uploader.Obj.methods._options.request.params.TrackingAlias =
        response.data.Alias;
      self.Uploader.Obj.methods._options.request.params.is_tracking = true;
      self.Uploader.Obj.methods.uploadStoredFiles();
    } else {
      self.__RegisterDone__(self);
    }
  }

  __OnRegisterSuccess__(self, response) {
    self.Uploader.Obj.methods._options.request.params.AssetAlias =
      response.data.Alias;
    self.Uploader.Obj.methods._options.request.params.TrackingAlias =
      response.data.Tracking.Alias;
    self.Uploader.Obj.methods._options.request.params.is_tracking = true;
    // if (self.state.Site !== ""){
    //     // TrackingPresenter.RegisterTracking(TrackingRequestProps.RegisterProps(self.__OnRegisterTrackingSuccess__,self.__OnRegisterFailed__,PermissionProperties.ASSET.TRACKING.REGISTER,response.data,self.state,self.props,self))
    //     self.__RegisterDone__(self)
    //     return
    // }else if(self.Uploader.Obj.methods.getFile(0) !==null){
    if (self.Uploader.Obj.methods.getFile(0) !== null) {
      self.Uploader.Obj.methods.uploadStoredFiles();
      // console.log(self.Uploader.Obj)
    } else {
      self.__RegisterDone__(self, response);
    }
    // this.__RegisterDone__(self)
  }
  __OnRegisterFailed__(error) {
    toast.error(MessageProperties.ERROR.MODEL.ERROR_SUBMIT + error.detail);
  }
 async __SaveAsset__() {
    if (!FormHelper.ValidateForm(this.state, MessageProperties,undefined,this.is_lite)) {
      return;
    }
    const {state} = this
    if(this.is_lite){
    const type = await Request(
      "get",
      "read-asset-type-autocomplete", 
      {},
      {search:""},
      [],
      ()=>null,
      ()=>null,
      undefined,
      null
    )
    const status = await Request(
      "get",
      "read-asset-status-autocomplete", 
      {},
      {search:""},
      [],
      ()=>null,
      ()=>null,
      undefined,
      null
    )
    if(type === null || status === null){
      this.__OnRegisterFailed__({detail:"network error"}) 
      return
    }
    state.Type = type.results[0].Alias
    const data = (status.results || []).find(item => item.Type === "idle")
    state.Status = data.Alias
    }
    Presenter.RegisterAsset(
      RequestProps.RegisterUpdateProps(
        this.__OnRegisterSuccess__,
        this.__OnRegisterFailed__,
        PermissionProperties.ASSET.ASSET.REGISTER,
        state,
        this.props,
        this
      )
    );
  }
  __RenderImageUploader__() {
    if (
      UserHelper.HasPermission(
        PermissionProperties.ASSET.IMAGE.REGISTER,
        this.props.UserReducer
      )
    ) {
      return <Gallery uploader={this.Uploader.Obj} />;
    }
  }

  goToAssetDetail() {
    let nextPath = "/admin";
    if (ReactNativeWebView) {
      nextPath = "/single-page";
    }
    this.props.history.push(
      nextPath +
        "/master-asset-details-" +
        this.Uploader.Obj.methods._options.request.params.AssetAlias +
        "/"
    );
  }

  /*=============== SITE COMPONENT================*/

  openModalRegisterSite(mode) {
    this.setState({
      modalRegisterSite: true
    });
  }

  closeModalRegisterSite() {
    windowStop();
    this.setState({ modalRegisterSite: false });
  }

  /* ======================= LOCATION COMPONENT ========================= */

  openModalRegisterLocation(mode) {
    this.setState({
      modalRegisterLocation: true
    });
  }

  closeModalRegisterLocation() {
    windowStop();
    this.setState({ modalRegisterLocation: false });
  }

  /* ======================= MAINTENANCE ========================= */

  toggleModalQuestion() {
    this.setState({ modalQuestion: !this.state.modalQuestion });
  }

  toggleModalMaintenance() {
    this.setState(
      { modalMaintenance: !this.state.modalMaintenance },
      () => !this.state.modalMaintenance && this.goToAssetDetail()
    );
  }

  /*onYesClick(){
    this.toggleModalMaintenance();
  }*/

  onNoClick() {
    this.goToAssetDetail();
  }

  onYesClick() {
    this.toggleModalMaintenance();
    this.toggleModalQuestion();
  }

  /* ======================= MOBILE COMPONENT ========================= */

  handleMobile({ data }) {
    let parsedData = JSON.parse(data);
    this.props.RunRedux(StoreUserInfoFromMobile(parsedData.UserReducer));
    if (parsedData.AssetTagReducer.tag) {
      this.props.RunRedux(
        Exec("SetAssetTag", { tag: parsedData.AssetTagReducer.tag })
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.AssetTagReducer.tag !== null) {
      this.setState({
        Tag: nextProps.AssetTagReducer.tag
      });
    }
    if (nextProps.UserReducer.username !== null) {
      this.setState({
        siteEdit: UserHelper.HasPermission(
          PermissionProperties.ASSET.TRACKING.REGISTER,
          nextProps.UserReducer
        )
      });
    }
  }

  componentWillUnmount() {
    this.props.RunRedux(Exec("SetAssetTag", { tag: null }));
    if (ReactNativeWebView) {
      window.removeEventListener("message", this.handleMobile);
      document.removeEventListener("message", this.handleMobile);
    }
    windowStop();
  }

  componentDidMount() {
    if (ReactNativeWebView) {
      window.addEventListener("message", this.handleMobile);
      document.addEventListener("message", this.handleMobile);
      ReactNativeWebView.postMessage("mounted");
    }
  }

  render() {
    /*const LocationOpt = this.LocationOption*/
    // FormHelper.InitOptionValue(this)
    this.is_lite = ReactNativeWebView && this.props.UserReducer.props.is_lite
    return (
      <div className="white-background">
        <div className="row">
          <div className="col-md-12">
            <div className="card-block white-background">
              <div className="page-header">
                <h4>Add New Asset</h4>
              </div>
              <hr />
              <div className="form-group">
                <div className="row">
                  <div className="form-group col-sm-12">
                    <label className="required">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="Name"
                      placeholder="Enter Asset Name"
                      onChange={event =>
                        this.setState({ Name: event.target.value })
                      }
                      tabIndex="1"
                    />
                  </div>

                  {/*  <div className="form-group col-sm-4">
                        <label>Tag</label>
                        <input
                          type="text"
                          className="form-control"
                          id="Tag"
                          placeholder="Enter Asset Tag"
                          onChange={(event)=> this.setState({Tag: event.target.value})}
                        />
                  </div>*/}
                </div>
              <div className="form-group">
                <label className="required">Description</label>
                <textarea
                  id="Description"
                  name="Description"
                  rows="5"
                  className="form-control"
                  placeholder="Enter Asset Description"
                  onChange={event =>
                    this.setState({ Description: event.target.value })
                  }
                  tabIndex="2"
                ></textarea>
              </div>
              <div className="row">
                <div className="form-group col-sm-4">
                  <label>Vendor Name</label>
                  <SelectQuery
                    placeholder="Type Vendor"
                    value={this.state.PurchaseVendorName}
                    onChange={event =>
                      this.__HandleChanged__("PurchaseVendorName", event)
                    }
                    urlKey="read-vendor-autocomplete"
                    valKey="Name"
                    valLabel="Name"
                    isCreatable={true}
                    UserReducer={this.props.UserReducer}
                    tabIndex="3"
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label>Purchase Order</label>
                  <input
                    type="text"
                    className="form-control"
                    id="PurchaseOrder"
                    placeholder="Purchase Order"
                    onChange={event =>
                      this.setState({ PurchaseOrder: event.target.value })
                    }
                    tabIndex="7"
                  />
                </div>
                {!this.is_lite && (
                  <div className="form-group col-sm-4">
                    <label className="required">Type</label>
                    <SelectQuery
                      name="Site"
                      placeholder="Asset Type"
                      value={this.state.Type}
                      urlKey="read-asset-type-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      onChange={event => this.setState({ Type: event.value })}
                      UserReducer={this.props.UserReducer}
                      disabled={!this.state.siteEdit}
                      tabIndex="11"
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="form-group col-sm-4">
                  <label>Make</label>
                  <PopoverHelper
                    id="admin_addregistration_make"
                    content={lang.admin_addregistration.make}
                  />
                  <SelectQuery
                    name="make"
                    placeholder="Type Make"
                    value={this.state.Make}
                    urlKey="read-make-autocomplete"
                    onChange={event => this.__HandleChanged__("Make", event)}
                    UserReducer={this.props.UserReducer}
                    isCreatable={true}
                    tabIndex="4"
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label>Purchased Date</label>
                  <DatePicker
                    id="PurchasedDate"
                    name="PurchasedDate"
                    className="form-control"
                    dateFormat="YYYY-MM-DD"
                    selected={this.state.PurchasedDate}
                    onChange={val => this.__OnPurchasedDateChange__(val, this)}
                    tabIndex="8"
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label>Max Day</label>
                  <PopoverHelper
                    id="admin_addregistration_max_day"
                    content={lang.admin_addregistration.max_day}
                  />
                  <input
                    type="number"
                    className="form-control"
                    min="0"
                    pattern="\d*"
                    id="maxDay"
                    placeholder="Enter Asset Max Day"
                    value={this.state.MaxDay}
                    onChange={event =>
                      this.setState({ MaxDay: event.target.value })
                    }
                    tabIndex="12"
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-4">
                  <label>Model</label>
                  <SelectQuery
                    name="model"
                    placeholder="Type Model"
                    value={this.state.Model}
                    urlKey="read-model-autocomplete"
                    onChange={event => this.__HandleChanged__("Model", event)}
                    isCreatable={true}
                    UserReducer={this.props.UserReducer}
                    tabIndex="5"
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label>Purchase Currency</label>
                  <SelectQuery
                    name="PurchaseCurrency"
                    placeholder="Currency"
                    value={this.state.PurchaseCurrency}
                    urlKey="read-currency-autocomplete"
                    valKey="pk"
                    valLabel="Name"
                    onChange={event =>
                      this.setState({ PurchaseCurrency: event.value })
                    }
                    UserReducer={this.props.UserReducer}
                    disabled={this.state.FieldDisabled}
                    tabIndex="10"
                  />
                  {/*<Input
                  type="select"
                  name="PurchaseCurrency"
                  id="PurchaseCurrency"
                  value={this.state.PurchaseCurrency}
                  onChange={(event)=> this.setState({PurchaseCurrency: event.target.value})}
                  tabIndex="9"
                  >
                   {this.renderHelper.RenderCurrenciesOption(this.props.CurrencyReducer)}
                 </Input>*/}
                </div>
                {!this.is_lite && (
                  <div className="form-group col-sm-4">
                    <label className="required">Status</label>
                    <PopoverHelper
                      id="admin_addregistration_status"
                      content={lang.admin_addregistration.status}
                    />
                    {/*<Select
                  placeholder="Type Asset Site"
                  disabled={!this.state.siteEdit}
                  value = {this.state.Status}
                  clearable={false}
                  options={this.renderHelper.RenderMasterAutoCompleteFilter(this.props.AssetStatusReducer, ['idle'] )}
                  onChange={(event)=> this.setState({Status: event.value})}
                  tabIndex="13"
                />*/}
                  <SelectQuery
                      name="Status"
                      placeholder="Asset Status"
                      value={this.state.Status}
                      urlKey="read-asset-status-autocomplete"
                      valKey="Alias"
                      valLabel="Name"
                      filterOptions={(opt, str, val) =>
                        opt.filter(opt => opt.Type === "idle")
                      }
                      onChange={event => this.setState({ Status: event.value })}
                      UserReducer={this.props.UserReducer}
                      disabled={!this.state.siteEdit}
                      tabIndex="13"
                    />
                  </div>
                )}

              </div>
              <div className="row">
                <div className="form-group col-sm-4">
                  <label className="required">Serial Number</label>
                  <input
                    type="text"
                    className="form-control"
                    id="SerialNumber"
                    placeholder="Enter Asset Serial Number"
                    onChange={event =>
                      this.setState({ SerialNumber: event.target.value })
                    }
                    tabIndex="6"
                  />
                </div>
                <div className="form-group col-sm-4">
                  <label>Purchase Price</label>
                  {ReactNativeWebView ? (
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      pattern="\d*"
                      id="PurchasePrice"
                      placeholder="Enter Asset Purchase Price"
                      value={this.state.PurchasePrice}
                      onChange={event =>
                        this.setState({ PurchasePrice: event.target.value })
                      }
                      tabIndex="10"
                    />
                  ) : (
                    <CurrencyInput
                      className="form-control"
                      id="PurchasePrice"
                      autoFocus={false}
                      // prefix        ={this.state.PurchaseCurrency +" "}
                      value={this.state.PurchasePrice}
                      onChangeEvent={this.handleChangePurchase}
                      tabIndex="10"
                    />
                  )}
                </div>
                <div className="form-group col-sm-4">
                  <label>Warranty (in Months)</label>
                  <div className="input-group suffix">
                    <input
                      type="number"
                      min="0"
                      pattern="\d*"
                      className="form-control"
                      placeholder="Warranty"
                      value={this.state.WarrantyPeriod}
                      onChange={e =>
                        this.setState({ WarrantyPeriod: e.target.value })
                      }
                      tabIndex="14"
                    />
                    <span className="input-group-addon white-background">
                      Months
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-8">
                  <div className="float-right">
                    <button
                      type="button"
                      style={{ fontSize: 12 }}
                      className="btn btn-sm btn-primary"
                      onClick={() => this.openModalRegisterSite()}
                    >
                      <i className="fa fa-plus-square"></i>
                    </button>
                  </div>
                  <label className="required">Site</label>
                  {/*<Select
                  name="Site"
                  placeholder="Type Asset Site"
                  disabled={!this.state.siteEdit}
                  value={this.state.Site}
                  options={this.renderHelper.RenderMasterAutoComplete(this.props.SiteReducer,true)}
                  onChange={(val)=>this.__HandleSiteChanged__(val)}
                  tabIndex="15"
                />*/}
                  <SelectQuery
                    name="Site"
                    placeholder="Type Asset Site"
                    value={this.state.Site}
                    urlKey="read-site-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    onChange={val => this.__HandleSiteChanged__(val)}
                    UserReducer={this.props.UserReducer}
                    disabled={!this.state.siteEdit}
                    tabIndex="15"
                  />
                </div>
                <div className="form-group col-sm-4">
                  <div className="float-right">
                    <button
                      type="button"
                      style={{
                        fontSize: 12,
                        display: this.state.Button ? "unset" : "none"
                      }}
                      className="btn btn-sm btn-primary"
                      onClick={() => this.openModalRegisterLocation()}
                    >
                      <i className="fa fa-plus-square"></i>
                    </button>
                  </div>
                  <label className="required">Location</label>
                  <SelectQuery
                    name="Location"
                    placeholder="Type Asset Location"
                    value={this.state.Location}
                    urlKey="read-location-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    extra={"site=" + this.state.Site}
                    onRef={asd => (this._location = asd)}
                    onChange={val => this.__HandleLocationChanged__(val)}
                    UserReducer={this.props.UserReducer}
                    disabled={!this.state.siteEdit}
                    tabIndex="16"
                  />
                </div>
              </div>
              <hr />
              <div className="right-align">
                <Button color="primary" onClick={() => this.__SaveAsset__()}>
                  Save
                </Button>{" "}
              </div>
            </div>
          </div>
          {/* <div className="col-md-4">
          <div className="card-block white-background registration-photo-container">
              {this.__RenderImageUploader__()}
          </div>
        </div> */}
        </div>
      </div>
        <ModalRegisterSite
          isModal={this.state.modalRegisterSite}
          open={this.openModalRegisterSite}
          close={this.closeModalRegisterSite}
          mode={"modal_add"}
          onSuccess={() => undefined}
          onFailed={() => undefined}
          data={""}
          is_process={this.state.is_process}
          UserReducer={this.props.UserReducer}
        />

        <ModalRegisterLocation
          isModal={this.state.modalRegisterLocation}
          open={this.openModalRegisterLocation}
          close={this.closeModalRegisterLocation}
          mode={"modal_add"}
          onSuccess={() => undefined}
          onFailed={() => undefined}
          data={{ site: this.siteData }}
          isFromSite={true}
          is_process={this.state.is_process}
          UserReducer={this.props.UserReducer}
        />
      
        <ModalQuestion
          isOpen={this.state.modalQuestion}
          toggle={() => this.toggleModalQuestion()}
          title="Maintenance"
          question="Do you want to input Maintenance data ?"
          onNoClick={() => this.onNoClick()}
          onYesClick={() => this.onYesClick()}
        />

        <ModalMaintenanceAdd
          toggleModalAdd={this.toggleModalMaintenance}
          modalAdd={this.state.modalMaintenance}
          UserReducer={this.props.UserReducer}
          loadData={() => null}
          assetData={{
            Alias: this.newAsset.Alias,
            Name: this.newAsset.Name
          }}
        />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    Reducer: state.AssetReducer,
    UserReducer: state.UserReducer,
    RequestReducer: state.RequestReducer,
    CurrencyReducer: state.CurrencyReducer,
    AssetStatusReducer: state.AssetStatusReducer,
    AssetTypeReducer: state.AssetTypeReducer,
    VendorReducer: state.VendorReducer,
    SiteReducer: state.SiteReducer,
    LocationReducer: state.LocationReducer,
    AssetTagReducer: state.AssetTagReducer,
    SiteTypeReducer: state.SiteTypeReducer,
    ContactReducer: state.ContactReducer,
    CityReducer: state.CityReducer,
    SiteStatusReducer: state.SiteStatusReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

// export default AssetScreen;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetRegistrationForm);



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/asset/form/registration.js